import { render, staticRenderFns } from "./PostFormObjectType.vue?vue&type=template&id=22654cd0&"
import script from "./PostFormObjectType.vue?vue&type=script&lang=js&"
export * from "./PostFormObjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports